import React, { FunctionComponent } from "react";

export const ActionsBar: FunctionComponent<React.PropsWithChildren<any>> = ({
  children,
}) => {
  return (
    <div className="actionsBar-container px-0">
      <div className="actionsBar actionsBar-hasSearch">{children}</div>
    </div>
  );
};
